<template>
  <div>
    <base-overlay :show="fetchingOrder">
      <b-row v-if="orderDetails">
        <b-col md="4">
          <b-card>
            <b-card-title>Business</b-card-title>
            <span class="font-weight-bold d-inline-block mb-1">Name En: </span> {{ orderDetails.business.name ? orderDetails.business.name.en : '' }}
            <br>
            <span class="font-weight-bold">Name Ar: </span> {{ orderDetails.business.name ? orderDetails.business.name.ar : '' }}
          </b-card>
        </b-col>
        <b-col md="4">
          <b-card>
            <b-card-title>Branch</b-card-title>
            <span class="font-weight-bold d-inline-block mb-1">Name En: </span> {{ orderDetails.business.branch.name ? orderDetails.business.branch.name.en : '' }}
            <br>
            <span class="font-weight-bold">Name Ar: </span> {{ orderDetails.business.branch.name ? orderDetails.business.branch.name.ar : '' }}
          </b-card>
        </b-col>
        <b-col md="4">
          <b-card>
            <b-card-title>User</b-card-title>
            <span class="font-weight-bold d-inline-block mb-1">Name: </span> {{ orderDetails.userDetails.firstName + ' ' + orderDetails.userDetails.lastName }}
            <br>
            <span class="font-weight-bold">Phone No: </span> {{ orderDetails.userDetails.phoneNumber }}
          </b-card>
        </b-col>
        <b-col md="12">

          <b-row class="d-flex">
            <b-col md="12">
              <b-card
                class="mb-0"
                style="height:100%"
              >
                <b-card-title class="d-flex justify-content-between align-items-center">
                  <div class="d-flex align-items-center">
                    <span class="mr-1">Order Details</span>
                    <b-badge
                      variant="light-primary"
                    >
                      {{ snakeCaseToCamelCase(orderDetails.state) }}
                    </b-badge>
                  </div>
                  <div class="d-flex">
                    <b-button
                      v-if="orderDetails.state == 'CREATED'"
                      variant="success"
                      class="mr-1"
                      :disabled="transitioningOrder"
                      @click="transitionOrder('ACCEPT')"
                    >
                      Accept
                    </b-button>
                    <b-button
                      v-if="orderDetails.state == 'CREATED'"
                      variant="danger"
                      class="mr-1"
                      :disabled="transitioningOrder"
                      @click="transitionOrder('DECLINE')"
                    >
                      Decline
                    </b-button>
                    <b-button
                      v-if="orderDetails.state == 'ACCEPTED'"
                      variant="danger"
                      class="mr-1"
                      :disabled="transitioningOrder"
                      @click="transitionOrder('CANCEL')"
                    >
                      Decline
                    </b-button>
                    <b-button
                      v-if="orderDetails.state == 'ACCEPTED'"
                      variant="warning"
                      class="mr-1"
                      :disabled="transitioningOrder"
                      @click="transitionOrder('PREPARE')"
                    >
                      Prepare
                    </b-button>
                    <b-button
                      v-if="orderDetails.state == 'PREPARATION'"
                      variant="primary"
                      :disabled="transitioningOrder"
                      @click="transitionOrder('READY')"
                    >
                      Ready
                    </b-button>
                  </div>
                </b-card-title>
                <b-row>
                  <b-col md="3">
                    <span class="font-weight-bold d-inline-block mb-1">Date: </span> {{ formatDate(orderDetails.createdAt) }}
                  </b-col>
                  <b-col md="3">
                    <span class="font-weight-bold d-inline-block mb-1">Number: </span> {{ orderDetails.number }}
                  </b-col>
                  <b-col md="3">
                    <span class="font-weight-bold d-inline-block mb-1">Total Price: </span> {{ orderDetails.totalPrice }}
                  </b-col>
                  <b-col md="3">
                    <span class="font-weight-bold d-inline-block mb-1">Tip: </span> {{ orderDetails.tip }}
                  </b-col>
                  <b-col
                    v-if="orderDetails.note"
                    md="12"
                  >
                    <span class="font-weight-bold d-inline-block mb-1">Note: </span> {{ orderDetails.note }}
                  </b-col>
                  <b-col
                    md="12"
                    class="my-1"
                  >
                    <b-table
                      :fields="itemsColumns"
                      :items="orderDetails.items"
                    >
                      <template #cell(show_details)="row">
                        <b-button
                          v-if="row.item.selectionGroups.length"
                          size="sm"
                          class="mr-2"
                          variant="primary"
                          @click="row.toggleDetails"
                        >
                          {{ row.detailsShowing ? 'Hide' : 'Show' }} Groups
                        </b-button>
                      </template>
                      <template #row-details="row">
                        <b-table
                          :fields="groupsColumns"
                          :items="row.item.selectionGroups"
                        >
                          <template #cell(show_details)="groupRow">
                            <b-button
                              v-if="groupRow.item.selections"
                              size="sm"
                              class="mr-2"
                              variant="primary"
                              @click="groupRow.toggleDetails"
                            >
                              {{ groupRow.detailsShowing ? 'Hide' : 'Show' }} Selections
                            </b-button>
                          </template>
                          <template #row-details="selectionsRow">
                            <b-table
                              :fields="selectionsColumns"
                              :items="selectionsRow.item.selections"
                            />
                          </template>
                        </b-table>
                      </template>
                    </b-table>
                  </b-col>
                  <b-col md="12">
                    <div id="TripMap" />
                  </b-col>
                </b-row>

              </b-card>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </base-overlay>
  </div>
</template>

<script>
/* eslint-disable no-undef */
import { onMounted, ref } from '@vue/composition-api'
import {
  BCard, BCardTitle, BRow, BCol, BBadge, BTable, BButton,
} from 'bootstrap-vue'
import BaseOverlay from '@/UI/BaseOverlay.vue'
import axiosIns from '@/libs/axios'
import formatDate from '@/utils/date-format'
import snakeCaseToCamelCase from '@/utils/snake-case-to-camcel-caase'
import { errorNotification } from '@/utils/toast-notifications'

export default {
  components: {
    BCard, BCardTitle, BRow, BCol, BaseOverlay, BBadge, BTable, BButton,
  },
  setup(_, ctx) {
    const orderID = ctx.root.$route.params.id
    const itemsColumns = [
      {
        label: 'Name',
        key: 'name',
        formatter: val => (val ? `${val.en} / ${val.ar}` : ''),
      },
      {
        label: 'quantity',
        key: 'quantity',
      },
      {
        label: 'price',
        key: 'price',
      },
      {
        label: 'total item price',
        key: 'totalItemPrice',
      },
      {
        label: 'Note',
        key: 'note',
      },
      {
        label: '',
        key: 'show_details',
      },
    ]
    const groupsColumns = [
      {
        label: 'Group Name',
        key: 'name',
        formatter: val => (val ? `${val.en} / ${val.ar}` : ''),
      },
      {
        label: 'Selections Price',
        key: 'selectionsPrice',
      },
      {
        label: '',
        key: 'show_details',
      },
    ]
    const selectionsColumns = [
      {
        label: 'name',
        key: 'name',
        formatter: val => (val ? `${val.en} / ${val.ar}` : ''),
      },
      {
        label: 'price',
        key: 'price',
      },
      {
        label: 'quantity',
        key: 'quantity',
      },
    ]

    const orderDetails = ref()
    const fetchingOrder = ref(false)
    const getOrder = async () => {
      fetchingOrder.value = true
      const res = await axiosIns.get(`/orders/${orderID}`)
      console.log(res.data.data)
      orderDetails.value = res.data.data
      fetchingOrder.value = false
      console.log(res, 'res')
    }
    const map = ref()
    const initMap = () => {
      const branchCoords = orderDetails.value.business.branch.location
      const deliverToCoords = orderDetails.value.deliverTo
      map.value = new google.maps.Map(document.getElementById('TripMap'), {
        center: {
          lat: branchCoords.lat,
          lng: branchCoords.lon,
        },
        zoom: 17,
      })
      // eslint-disable-next-line no-new
      new google.maps.Marker({
        position: {
          lat: branchCoords.lat,
          lng: branchCoords.lon,
        },
        icon: {
          scaledSize: new google.maps.Size(50, 50),
          anchor: new google.maps.Point(30, 30),
          url: 'https://cdn4.iconfinder.com/data/icons/map-pins-2/256/21-512.png',
        },
        map: map.value,
      })
      // eslint-disable-next-line no-new
      new google.maps.Marker({
        position: {
          lat: deliverToCoords.lat,
          lng: deliverToCoords.lon,
        },
        map: map.value,
      })
    }
    const transitioningOrder = ref(false)
    const transitionOrder = async action => {
      try {
        transitioningOrder.value = true
        await axiosIns.post(`/orders/${orderID}/transitions`, {
          action,
        })
        getOrder()
      } catch (err) {
        errorNotification('Something went wrong')
      } finally {
        transitioningOrder.value = false
      }
    }

    onMounted(async () => {
      await getOrder()
      initMap()
    })

    return {
      orderID,
      orderDetails,
      transitioningOrder,
      transitionOrder,
      formatDate,
      groupsColumns,
      itemsColumns,
      snakeCaseToCamelCase,
      fetchingOrder,
      selectionsColumns,
      getOrder,
    }
  },
}
</script>

<style scoped>
#TripMap {
  width: 100%;
  height: 250px;
}
</style>
